import * as Yup from 'yup';

import { TERMS_AGREEMENT } from '../../../forms/fields/AgreeToTermsField';
import { validationMessages } from '../../../forms/messages/validationMessages';

export const getValidationSchema = formatMessage =>
    Yup.object().shape({
        [TERMS_AGREEMENT]: Yup.boolean()
            .default(false)
            .test('agreed-to-terms', formatMessage(validationMessages.termsAgreement), value => value === true),
        currencyCode: Yup.string()
            .length(3)
            .required()
    });
